import { render, staticRenderFns } from "./fixedBotton.vue?vue&type=template&id=2fd1bbe0&scoped=true"
import script from "./fixedBotton.vue?vue&type=script&lang=js"
export * from "./fixedBotton.vue?vue&type=script&lang=js"
import style0 from "./fixedBotton.vue?vue&type=style&index=0&id=2fd1bbe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1bbe0",
  null
  
)

export default component.exports